import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";
import { AuthService } from '../../services/auth.service';
import { UserIdentity } from "../../models/user-identity.model";

// Checks if user is internal
@Injectable()
export class InternalGuardService  {

    constructor(
        public service: AuthService,
        public router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        let obs$: Observable<boolean | UrlTree>;
        const unauthorized$ = of(this.router.createUrlTree(['/home/unauthorized', { ref: state.url }], /* Removed unsupported properties by Angular migration: skipLocationChange. */ {}));
        obs$ = this.service.token$.pipe(
            take(1),
            mergeMap((token) => {
                let returnObs$: Observable<boolean | UrlTree> = of(false);
                if (token == null || token === "") {
                    returnObs$ = this.service.setProfile().pipe(
                        mergeMap((identity: UserIdentity) => {
                            return (identity.isLoggedIn && identity.isInternal)
                                ? of(true)
                                : unauthorized$;
                        })
                    );
                } else {
                    returnObs$ = (this.service.User.isInternal)
                        ? of(true)
                        : unauthorized$;
                }
                return returnObs$;
            })
        );
        return obs$;
    }

}
